import hrms55xLabels from 'assets/labels/hrms55x'
import faker from 'faker'
import moment from 'moment'

export const mocker = {
  labels () {
    return {
      labels: hrms55xLabels
    }
  },
  index () {
    let mockRows = []
    const mockTotal = 10
    for (var i = 1; i <= mockTotal; i++) {
      mockRows.push({
        id: i,
        codempid: faker.lorem.word(),
        desc_codempid: faker.name.findName(),
        dtework: moment().format('DD/MM/YYYY'),
        codshift: faker.address.stateAbbr(),
        desc_codshift: faker.name.findName(),
        timinoutw: faker.date.past().toString().substr(16, 5) + ' - ' + faker.date.past().toString().substr(16, 5),
        codleave: faker.address.stateAbbr(),
        desc_codleave: faker.name.findName(),
        timinoutl: '08:00-17:00',
        qtyleave: '8:00',
        staappr: faker.address.stateAbbr(),
        desc_staappr: faker.name.findName()
      })
    }

    return {
      total: mockTotal,
      rows: mockRows
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/hrms55x/mocker.js